export default "__VITE_ASSET__biQTSaO2__"